import * as _ from "lodash";
import * as $ from "jquery";
import {TeamOverviewView} from "./TeamOverviewView";
import {ModifyTeamModal} from "./TeamModals";
import {BaseAccountListView, BaseAccountViewOptions} from "../_BaseAccountViews";
import {BaseList, TableProperties} from "../../_BaseList";
import {GenericDeleteModal} from "../../modals/GenericDeleteModal";
import {Intercom} from "../../../common/intercom";

require('bootstrap-toggle');


export class TeamAccountView extends BaseAccountListView {

    show(orgId, groupId?, detail?, subDetail?, subDetailId?) {
        var view;
        if (groupId) {
            view = new TeamOverviewView(this.options);
        } else {
            view = new TeamAccountListView(this.options);
        }

        this.$el.empty().append(view.render().$el);
        view.show(groupId, detail, subDetail, subDetailId);
        this.subViews.push(view);
    }

    render() {
        this.$el.html('');
        return this;
    }
}

export class TeamAccountListView extends BaseAccountListView {

    constructor(options: BaseAccountViewOptions) {
        super(<any> _.extend({}, options, {
            tagName: 'div',
            events: {
                'click .add-usergroup': 'handleCreateGroupButtonClick',
                'click .delete-from-list': 'handleDeleteUserGroup',
            }
        }));
    }

    show(groupId?, detail?, subDetail?, subDetailId?) {
        this.collectionLoaded = true;
        this.render();
    }

    render() {
        this.$el.html(this.template({
            organizationCollection: this.options.organizationCollection,
            permissionCollection: this.options.permissionCollection,
            currentOrganizationId: this.options.currentOrganizationId,
            collectionLoaded: this.collectionLoaded,
            urlAddon: '/teams',
        }));

        var canAdd = this.options.permissionCollection.canCreateNewUserGroup(this.options.currentOrganizationId);
        this.$('.container').append(this.panelTemplate({
            panelTitle: {text: 'Teams', url: null},
            panelClass: 'team-list',
            panelWidth: '',
            headerLink: null,
            addButton: {canAdd: canAdd, label: "Add Team", 'class': "add-usergroup"},
            search: true,
            collectionLoaded: this.collectionLoaded,
            footer: null
        }));

        this.showBreadcrumbs(this.options.organizationCollection.findWhere({
            id: this.options.currentOrganizationId
        }));
        if (this.collectionLoaded) this.showTable();
        this.delegateEvents();
        return this;
    }

    showTable() {
        var teamTable = new BaseList(this.options);
        var teamTableProperties: TableProperties = {
            canDeletePermissionFunction: this.options.permissionCollection.canDeleteUserGroup.bind(this.options.permissionCollection),
            canDeletePermissionFunctionAttribute: 'id',
            rowUrl: '#/account/' + this.options.currentOrganizationId + '/teams/',
            tableEmptyText: 'There are no Teams',
            columnProperties: {
                'Team Name': {
                    attribute: 'name',
                    columnSizes: {
                        'sm': '4',
                        'md': '4',
                        'xs': '4'
                    }
                },
                'Users': {
                    customColumn: {
                        templateFunction: _.template(
                            '<div class="col-md-6 col-sm-6 col-xs-6 account-team-users clickable">' +
                            '<% users = []; %>' +
                            '<% userCollection.each(function(user){if(_.includes(_.map(_.keys(user.get("usergroups")),' +
                            'Number), mod.get("id"))){ users.push(user.get("name"))}}); %> ' +
                            '<%- users.sort().join(", ") %>' +
                            '</div>'
                        ),
                        variables: {
                            userCollection: this.options.userCollection,
                            userGroupCollection: this.options.userGroupCollection,
                            currentOrganizationId: this.options.currentOrganizationId
                        }
                    },
                    columnSizes: {
                        'sm': '6',
                        'md': '6',
                        'xs': '6'
                    }
                }
            }
        };

        this.$('.team-list .panel-body > .row').append(
            teamTable.renderCollectionList(this.options.userGroupCollection, teamTableProperties).$el
        );
    }

    showBreadcrumbs(org) {
        super.showBreadcrumbs('Teams', 'Categories');
    }

    handleCreateGroupButtonClick() {
        var view = new ModifyTeamModal(_.extend({}, this.options, {
            userGroupCollection: this.options.userGroupCollection,
            userCollection: this.options.userCollection,
        }));
        $('.modals').append(view.render().$el);
        view.show();
    }

    handleDeleteUserGroup(e: JQuery.UIEventBase) {
        e.stopPropagation();
        var id = Number($(e.currentTarget).attr('data-model-id'));
        var group = this.options.userGroupCollection.findWhere({id: id});

        var modal = new GenericDeleteModal({
            type: 'Team',
            name: group.get('name'),
            func: () => {
                return $.ajax({
                    type: "DELETE",
                    url: this.options.userGroupCollection.url() + '/' + id,
                    dataType: 'json',
                    contentType: "application/json; charset=utf-8",
                    complete: () => {
                        this.reloadUrl();

                        Intercom.trackEvent('deleted-team', {
                            org_id: this.options.currentOrganizationId,
                            team_id: id
                        });
                    }
                });
            }
        });
        $('.modals').append(modal.render().el);
        modal.show();
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/account/team/TeamAccountView.ts